import { Route, Routes } from "react-router-dom";
import Wrap from "../../hoc/Wrap";
import AppointmentCalendar from "./AppointmentCalendar";
import { useSelector } from "react-redux";
import NewAppointment from "./NewAppointmentsContainer/NewAppointmentCalendar";
import withReduxState from "../../hoc/wReduxState";
import NewPatientAppointmentContainer from "./EmployerAdminAppointmentContainer/EmployerAdminAppointmentContainer";

const Appointments = (props) => {
  const isNewUI = useSelector((state) => state.common.isNewUI);
  // Check for employee login safely using optional chaining
  const isEmployerAdmin = props.profile?.role === 'employer_admin';
  console.log("Is Employee Login:", isEmployerAdmin);
  // 1. If Employee Login -> Render NewPatientAppointmentContainer
  // 2. Else -> Check isNewUI (NewAppointment vs AppointmentCalendar)
  let ActiveComponent;

  if (isEmployerAdmin) {
    ActiveComponent = NewPatientAppointmentContainer;
  } else {
    ActiveComponent = isNewUI ? NewAppointment : AppointmentCalendar;
  }
  return (
    <Wrap>
      <Routes>
      
        <Route path="/" key={0} element={<ActiveComponent />} />
      </Routes>
</Wrap>
  );
};

export default withReduxState(Appointments);
